import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AppHeader } from "@/nav/AppHeader";
import { feasibilityApi } from "@/api";
import "./staff.css";

/** Chrome for the authenticated staff console: the two-tier AppHeader (sections
 *  + sub-views) above the routed page. Rendered only behind the admin gate
 *  (see StaffApp). */
export function StaffLayout() {
  // Wake the Modal engine once per staff session: it scales to zero and boots in ~5 s, and the
  // first thing many sessions do is open a lead (Suggest / the feasibility form). The drawer
  // pings again on open; this covers the straight-to-a-lead path, e.g. from a push notification.
  useEffect(() => {
    feasibilityApi.warmEngine();
  }, []);

  // The leads kanban, the wide cross-job invoices table, the tasks board, the
  // jobs triage table, and the application review queue all need more room than
  // the default content width. (The tasks *list* and the job *detail* page stay
  // at the default reading width — only /staff/tasks/board and the exact
  // /staff/jobs list widen.)
  const path = useLocation().pathname;
  const wide =
    path.startsWith("/staff/leads") ||
    path.startsWith("/staff/invoices") ||
    path.startsWith("/staff/tasks/board") ||
    path.startsWith("/staff/review") ||
    path.startsWith("/staff/chat") ||
    path === "/staff/jobs" ||
    path === "/staff/jobs/" ||
    path === "/staff/jobs/archive";
  return (
    <div className="staff">
      <AppHeader />
      <main className={`staff__main${wide ? " staff__main--wide" : ""}`}>
        <Outlet />
      </main>
    </div>
  );
}
